/* **************************************************** Finishing Shedule Item */
export interface FSItem {
    id: number;
    category: string;
    item_name: string;
    created_by: number | null;
}

export const mapFSItem = (data: any): FSItem => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSItem = {
        id: data.id,
        category: data.category,
        item_name: data.item_name,
        created_by: data.created_by || null,
    };

    return res;
};

export const mapFSItems = (data: any[]): FSItem[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSItem);
};
